import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Public from "@/layouts/Public.vue";
import Private from "@/layouts/Private.vue";

import PatientList from "@/views/patients/PatientList.vue";
import PatientDetails from "@/views/patients/PatientDetails.vue";
import PatientProfile from "@/views/patients/PatientProfile.vue";
import PatientCompletion from "@/views/patients/PatientCompletion.vue";


import InsurancesList from "@/views/insurances/InsurancesList.vue";
import InsurancesDetails from "@/views/insurances/InsurancesDetails.vue";

import OdontogramsList from "@/views/odontograms/OdontogramsList.vue";
import OdontogramsDetails from "@/views/odontograms/OdontogramsDetails.vue";

import PrescriptionsList from "@/views/prescriptions/PrescriptionsList.vue";
import PrescriptionsDetails from "@/views/prescriptions/PrescriptionsDetails.vue";

import DsdList from '@/views/dsd/DsdList.vue';
import DsdDetails from '@/views/dsd/DsdDetails.vue';
import DsdAssets from '@/views/dsd/DsdAssets.vue';

import AppointmentsList from "@/views/appointments/AppointmentsList.vue";
import AppointmentsDetails from "@/views/appointments/AppointmentsDetails.vue";
import CalendarView from "@/views/calendar/CalendarView.vue";

import TestsList from "@/views/tests/TestsList.vue";
import TestsDetails from "@/views/tests/TestsDetails.vue";

import AllergiesList from "@/views/allergies/AllergiesList.vue";
import AllergiesDetails from "@/views/allergies/AllergiesDetails.vue";

import AdminList from "@/views/admin/AdminList.vue";
import AdminDetails from "@/views/admin/AdminDetails.vue";

import RoleList from "@/views/role/RoleList.vue";
import RoleDetails from "@/views/role/RoleDetails.vue"

import ProposalsList from "@/views/proposals/ProposalsList.vue";
import ProposalsDetails from "@/views/proposals/ProposalsDetails.vue";

import ProceduresList from "@/views/procedures/ProceduresList.vue";
import ProceduresDetails from "@/views/procedures/ProceduresDetails.vue";

import SpecialtiesList from "@/views/specialties/SpecialtiesList.vue";
import SpecialtiesDetails from "@/views/specialties/SpecialtiesDetails.vue";

import AccountManagement from "@/views/account/AccountManagement.vue";
import ExamTypesList from "@/views/exam-types/ExamTypesList.vue";
import ExamTypesDetails from "@/views/exam-types/ExamTypesDetails.vue";
import LaboratoriesList from "@/views/laboratories/LaboratoriesList.vue";
import LaboratoriesDetails from "@/views/laboratories/LaboratoriesDetails.vue";


// import Patient

//import PaymentTotemList from "@/views/payment-totem/PaymentTotemList.vue";
//import PaymentTotemDetails from "@/views/payment-totem/PaymentTotemDetails.vue";

const guard = function(to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );
  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/login",
    });
  } else {
    if (to.name == "Home") {
      next();
      return;
    }

    next();
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Public,
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/cadastro-paciente/:token",
        name: "PatientCompletion",
        component: PatientCompletion,
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/",
    component: Private,
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        beforeEnter: guard,
      },
      {
        path: "/pacientes",
        name: "PatientList",
        component: PatientList,
        beforeEnter: guard,
      },
      {
        path: "/pacientes/novo",
        name: "PatientCreate",
        component: PatientDetails,
        beforeEnter: guard,
      },
      {
        path: "/pacientes/:id/perfil",
        name: "PatientProfile",
        component: PatientProfile,
        beforeEnter: guard,
      },
      {
        path: "/pacientes/:id",
        name: "PatientDetails",
        component: PatientDetails,
        beforeEnter: guard,
      },
      {
        path: "/convenios",
        name: "InsurancesList",
        component: InsurancesList,
        beforeEnter: guard,
      },
      {
        path: "/convenios/novo",
        name: "InsurancesCreate",
        component: InsurancesDetails,
        beforeEnter: guard,
      },
      {
        path: "/convenios/:id",
        name: "InsurancesDetails",
        component: InsurancesDetails,
        beforeEnter: guard,
      },
      {
        path: "/odontogramas",
        name: "OdontogramsList",
        component: OdontogramsList,
        beforeEnter: guard,
      },
      {
        path: "/odontogramas/novo",
        name: "OdontogramsCreate",
        component: OdontogramsDetails,
        beforeEnter: guard,
      },
      {
        path: "/odontogramas/:id",
        name: "OdontogramsDetails",
        component: OdontogramsDetails,
        beforeEnter: guard,
      },
      {
        path: "/prescricoes",
        name: "PrescriptionsList",
        component: PrescriptionsList,
        beforeEnter: guard,
      },
      {
        path: "/prescricoes/novo",
        name: "PrescriptionsCreate",
        component: PrescriptionsDetails,
        beforeEnter: guard,
      },
      {
        path: "/prescricoes/:id",
        name: "PrescriptionsEdit",
        component: PrescriptionsDetails,
        beforeEnter: guard,
      },
      {
        path: "/dsd",
        name: "DsdList",
        component: DsdList,
        beforeEnter: guard,
      },
      {
        path: "/dsd/imagens",
        name: "DsdAssets",
        component: DsdAssets,
        beforeEnter: guard,
      },
      {
        path: "/dsd/novo",
        name: "DsdCreate",
        component: DsdDetails,
        beforeEnter: guard,
      },
      {
        path: "/dsd/:id",
        name: "DsdEdit",
        component: DsdDetails,
        beforeEnter: guard,
      },
      {
        path: "/consultas",
        name: "AppointmentsList",
        component: AppointmentsList,
        beforeEnter: guard,
      },
      {
        path: "/consultas/novo",
        name: "AppointmentsCreate",
        component: AppointmentsDetails,
        beforeEnter: guard,
      },
      {
        path: "/consultas/:id",
        name: "AppointmentsEdit",
        component: AppointmentsDetails,
        beforeEnter: guard,
      },
      {
        path: "/calendario",
        name: "CalendarView",
        component: CalendarView,
        beforeEnter: guard,
      },
      {
        path: "/exames",
        name: "TestsList",
        component: TestsList,
        beforeEnter: guard,
      },
      {
        path: "/exames/novo",
        name: "TestsCreate",
        component: TestsDetails,
        beforeEnter: guard,
      },
      {
        path: "/exames/:id",
        name: "TestsEdit",
        component: TestsDetails,
        beforeEnter: guard,
      },
      {
        path: "/alergias",
        name: "AllergiesList",
        component: AllergiesList,
        beforeEnter: guard,
      },
      {
        path: "/alergias/novo",
        name: "AllergiesCreate",
        component: AllergiesDetails,
        beforeEnter: guard,
      },
      {
        path: "/alergias/:id",
        name: "AllergiesEdit",
        component: AllergiesDetails,
        beforeEnter: guard,
      },
      {
        path: "/assinaturas",
        redirect: "/home",
      },
      {
        path: "/assinaturas/:id/pagamentos",
        redirect: "/home",
      },
      {
        path: "/administradores",
        name: "AdminList",
        component: AdminList,
        beforeEnter: guard,
      },
      {
        path: "/administradores/novo",
        name: "AdminCreate",
        component: AdminDetails,
        beforeEnter: guard,
      },
      {
        path: "/administradores/:id",
        name: "AdminDetails",
        component: AdminDetails,
        beforeEnter: guard,
      },
      {
        path: "/dentistas",
        name: "DentistList",
        component: AdminList,
        props: { dentistMode: true },
        beforeEnter: guard,
      },
      {
        path: "/dentistas/novo",
        name: "DentistCreate",
        component: AdminDetails,
        props: { dentistMode: true },
        beforeEnter: guard,
      },
      {
        path: "/dentistas/:id",
        name: "DentistDetails",
        component: AdminDetails,
        props: { dentistMode: true },
        beforeEnter: guard,
      },
      {
        path: "/cargos",
        name: "RoleList",
        component: RoleList,
        beforeEnter: guard,
      },
      {
        path: "/cargos/novo",
        name: "RoleCreate",
        component: RoleDetails,
        beforeEnter: guard,
      },
      {
        path: "/cargos/:id",
        name: "RoleDetails",
        component: RoleDetails,
        beforeEnter: guard,
      },
      {
        path: "/orcamentos",
        name: "ProposalsList",
        component: ProposalsList,
        beforeEnter: guard,
      },
      {
        path: "/orcamentos/novo",
        name: "ProposalsCreate",
        component: ProposalsDetails,
        beforeEnter: guard,
      },
      {
        path: "/orcamentos/:id",
        name: "ProposalsEdit",
        component: ProposalsDetails,
        beforeEnter: guard,
      },
      {
        path: "/procedimentos",
        name: "ProceduresList",
        component: ProceduresList,
        beforeEnter: guard,
      },
      {
        path: "/procedimentos/novo",
        name: "ProceduresCreate",
        component: ProceduresDetails,
        beforeEnter: guard,
      },
      {
        path: "/procedimentos/:id",
        name: "ProceduresEdit",
        component: ProceduresDetails,
        beforeEnter: guard,
      },
      {
        path: "/especialidades",
        name: "SpecialtiesList",
        component: SpecialtiesList,
        beforeEnter: guard,
      },
      {
        path: "/especialidades/novo",
        name: "SpecialtiesCreate",
        component: SpecialtiesDetails,
        beforeEnter: guard,
      },
      {
        path: "/especialidades/:id",
        name: "SpecialtiesEdit",
        component: SpecialtiesDetails,
        beforeEnter: guard,
      },
      {
        path: "/minha-conta",
        name: "AccountManagement",
        component: AccountManagement,
        beforeEnter: guard,
      },
      {
        path: "/tipos-de-exame",
        name: "ExamTypesList",
        component: ExamTypesList,
        beforeEnter: guard,
      },
      {
        path: "/tipos-de-exame/novo",
        name: "ExamTypesCreate",
        component: ExamTypesDetails,
        beforeEnter: guard,
      },
      {
        path: "/tipos-de-exame/:id",
        name: "ExamTypesEdit",
        component: ExamTypesDetails,
        beforeEnter: guard,
      },
      {
        path: "/laboratorios",
        name: "LaboratoriesList",
        component: LaboratoriesList,
        beforeEnter: guard,
      },
      {
        path: "/laboratorios/novo",
        name: "LaboratoriesCreate",
        component: LaboratoriesDetails,
        beforeEnter: guard,
      },
      {
        path: "/laboratorios/:id",
        name: "LaboratoriesEdit",
        component: LaboratoriesDetails,
        beforeEnter: guard,
      },


      // {
      //   path: "/veiculos/:id",
      //   name: "VehicleDetails",
      //   component: VehicleDetails,
      //   beforeEnter: guard,
      //   meta: { permissions: ['vehicles.find', 'vehicles.update', 'vehicles.create'] }
      // },
      // {
      //   path: "/totens/:id",
      //   name: "PaymentTotemDetails",
      //   component: PaymentTotemDetails,
      //   beforeEnter: guard,
      // },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
